/**
 * Owner: Masa Bayu
 * File: WorldFacetField.tsx
 * Date:Time: 2026-09-27 06:31
 * Description: Searchable language/country facet — quiet select · no chip dump.
 */

import { useState } from 'react';
import {
  filterWorldFacetOptions,
  type WorldFacetOption,
} from './world-facets';

export interface WorldFacetFieldProps {
  readonly label: string;
  readonly anyLabel: string;
  readonly searchPlaceholder: string;
  readonly options: readonly WorldFacetOption[];
  readonly value: string;
  readonly onChange: (next: string) => void;
  readonly selectAriaLabel: string;
  readonly searchAriaLabel: string;
}

export function WorldFacetField({
  label,
  anyLabel,
  searchPlaceholder,
  options,
  value,
  onChange,
  selectAriaLabel,
  searchAriaLabel,
}: WorldFacetFieldProps) {
  const [query, setQuery] = useState('');
  const visible = filterWorldFacetOptions(options, query);
  const selected = options.find((opt) => opt.id === value);
  const selectOptions =
    selected && !visible.some((opt) => opt.id === selected.id)
      ? [selected, ...visible]
      : visible;

  return (
    <label className="world-facet">
      <span className="world-facet__label">{label}</span>
      <input
        type="search"
        className="world-facet__search"
        value={query}
        placeholder={searchPlaceholder}
        autoComplete="off"
        aria-label={searchAriaLabel}
        onChange={(event) => {
          setQuery(event.target.value);
        }}
      />
      <select
        className="world-facet__select"
        value={value}
        aria-label={selectAriaLabel}
        onChange={(event) => {
          onChange(event.target.value);
          setQuery('');
        }}
      >
        <option value="">{anyLabel}</option>
        {selectOptions.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}
